import {useMemo, useState} from 'react';
import Table from '../../Table';
import ModifyDateModal from '../../ModifyDateModal';
import ConfirmModal from '../../ConfirmModal';
import { today } from '../../../utils/utils';

const PanelTtlQueueManager = (props) => {
  const {
    api,
    appConfig,
    slots = {},
    isLoading = false,
    onViewTtl,
    triggerTimelineTemplates,
    handleBackToTtlForm,
    clearSelectedTtlInState
  } = props;

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteCampaignModal, setShowDeleteCampaignModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  
  const [showDateModal, setShowDateModal] = useState(false);
  const [itemToEdit, setItemToEdit] = useState(null);

  const [persistenceNotificationDate, setPersistenceNotificationDate] = useState('');
  const [startCampaignDate, setStartCampaignDate] = useState('');
  const [campaignEndDate, setCampaignEndDate] = useState('');

  const [activeButtonAction, setActiveButtonAction] = useState({ index: null, type: null });

  const isDeleteCampaignButtonDisabled = isLoading || !Array.isArray(slots?.ttl) || slots?.ttl.length === 0;

  const getTtlTitle = (
    title,
    templateType,
    fallback = 'Senza titolo'
  ) => {
    const cleanTitle = title?.trim();
    if (cleanTitle) return cleanTitle;

    if (
      templateType &&
      templateType !== 'DEFAULT' &&
      Array.isArray(triggerTimelineTemplates) &&
      triggerTimelineTemplates.length
    ) {
      const template = triggerTimelineTemplates.find(t => t.id === templateType);
      const description = template?.description?.trim();
      if (description) return description;
    }
    return fallback;
  }

  const deleteTitle = (
    itemToDelete && getTtlTitle(
      itemToDelete?.title,
      itemToDelete?.triggerTimelineTemplateId
    )) || '';

  const editTitle =(
    itemToEdit && getTtlTitle(
      itemToEdit?.templateInfo?.title,
      itemToEdit?.templateInfo?.triggerTimelineTemplateId
    )) || '';

  const minDate = useMemo(() => {
    if (!startCampaignDate) {
      return today();
    }
    const t = today();
    return startCampaignDate < t ? t : startCampaignDate;
  }, [startCampaignDate]);

  const dateFields = useMemo(
    () => [
      {
        name: 'expiringCampaignDate',
        label: 'Fine campagna',
        value: campaignEndDate,
        min: minDate,
        onChange: setCampaignEndDate
      },
      {
        name: 'persistenceNotificationDate',
        label: 'Durata Notifica',
        value: persistenceNotificationDate,
        min: minDate,
        onChange: setPersistenceNotificationDate
      }
    ],
    [campaignEndDate, persistenceNotificationDate, minDate]
  );

  const clearActiveButtonAction = () => setActiveButtonAction({ index: null, type: null });

  const setViewModeForCurrentRow = () => {
    setActiveButtonAction(prev => {
      if (prev.index === null || prev.index === undefined) {
        return prev;
      }
      return { index: prev.index, type: 'view' };
    });
  };

  const columns = useMemo(
    () => [
      {
        id: 'ttl',
        label: 'Lista TTL',
        align: 'left',
        minWidth: 200
      },
      {
        id: 'actions',
        label: '',
        align: 'right',
        minWidth: 120
      }
    ],
    []
  );

  const rows = useMemo(
    () =>
      slots?.ttl.map((ttl, index) => {
        const title = getTtlTitle(
          ttl.templateInfo?.title,
          ttl?.templateInfo?.triggerTimelineTemplateId
        );
        const id = ttl?.key?.idPushTTL || title;

        return {
          id,
          ttl: (
            <span className="ttl-title">
              {title}
            </span>
          ),
          actions: (
            <div className="ttl-actions">
              <div
                role="button"
                className={`ttl-action-btn view ${
                  activeButtonAction.index === index && activeButtonAction.type === 'view' ? 'active' : ''
                }`}
                aria-label="Visualizza TTL"
                onClick={(e) => {
                  e.stopPropagation();
                  setActiveButtonAction(prev =>
                    prev.index === index && prev.type === 'view'
                      ? { index: null, type: null }
                      : { index, type: 'view' }
                  );
                  onViewTtl && onViewTtl(ttl);
                }}
              >
                <i className="nexi-icon-focus-eye"></i>
              </div>
              <div
                role="button"
                className={`ttl-action-btn edit ${
                  activeButtonAction.index === index && activeButtonAction.type === 'edit' ? 'active' : ''
                }`}
                aria-label="Modifica TTL"
                onClick={(e) => {
                  e.stopPropagation();
                  setActiveButtonAction(prev =>
                    prev.index === index && prev.type === 'edit'
                      ? { index: null, type: null }
                      : { index, type: 'edit' }
                  );
                  handleOpenDateModal(ttl);
                  onViewTtl && onViewTtl(ttl);
                }}
              >
                <i className="nexi-icon-pencil"></i>
              </div>
              <div
                role="button"
                className={`ttl-action-btn delete ${
                  activeButtonAction.index === index && activeButtonAction.type === 'delete' ? 'active' : ''
                }`}
                aria-label="Elimina TTL"
                onClick={(e) => {
                  e.stopPropagation();
                  setActiveButtonAction(prev =>
                    prev.index === index && prev.type === 'delete'
                      ? { index: null, type: null }
                      : { index, type: 'delete' }
                  );
                  handleDeleteClick(ttl);
                  onViewTtl && onViewTtl(ttl);
                }}
              >
                <i className="nexi-icon-trash"></i>
              </div>
            </div>
          ),
          payload: ttl
        };
      }),
    [slots?.ttl, onViewTtl, activeButtonAction]
  );

  //======= Delete Campaign =========
  const handleDeleteCampaignClick = (e) => {
    e.preventDefault();
    setShowDeleteCampaignModal(true);
  };

  const handleConfirmDeleteCampaign = async() => {
    const payload = {
      idJourney: appConfig.idJourney,
      version: slots?.selectedCampaign?.version,
      templateType: slots?.selectedCampaign?.templateType
    }
    const response = await api.deleteCampaign(payload)
    if (response && response.status === 200) {
      api.getTemplate();
      handleBackToTtlForm();
    }
    setShowDeleteCampaignModal(false);
  }

  const onCancelDeleteCampaign = () => {
    setShowDeleteCampaignModal(false);
  };

  //======= Delete single banner =========
  const handleDeleteClick = (item) => {
    const { idPushTTL, idJourney, version } = item.key ?? {};
    setItemToDelete({
      idPushTTL,
      idJourney,
      version,
      title: item?.templateInfo?.title?.trim() ?? '',
      templateType: item?.templateInfo?.templateType ?? '',
      triggerTimelineTemplateId: item?.templateInfo?.triggerTimelineTemplateId ?? ''
    });
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    const payload = {
      key: {
        idPushTTL: itemToDelete.idPushTTL,
        idJourney: itemToDelete.idJourney,
        version: itemToDelete.version
      }
    }
    const response = await api.deleteSingleTemplate(payload)
    if (response && response.status === 200) {
      const runningConfResponse = await api.getRunningConfiguration(slots?.selectedCampaign?.version, slots?.selectedCampaign?.templateType)
      if(
        runningConfResponse && runningConfResponse.status === 200 &&
        runningConfResponse.data &&
        runningConfResponse?.data?.slots && runningConfResponse?.data?.slots?.ttl?.length === 0
      ) {
        handleBackToTtlForm()
      }
    }
    setShowDeleteModal(false);
    clearActiveButtonAction();
    clearSelectedTtlInState && clearSelectedTtlInState();
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
    setViewModeForCurrentRow();
  };

  //======= Modify date =========
  const handleOpenDateModal = (ttl) => {
    setItemToEdit(ttl);

    setCampaignEndDate(ttl?.templateInfo?.endCampaignDate || '');
    setPersistenceNotificationDate(ttl?.templateInfo?.persistenceNotificationDate || '');
    const startDate =
      ttl?.templateInfo?.startCampaignDate || today();
    setStartCampaignDate(startDate || null);

    setShowDateModal(true);
  };

  const handleCancelDate = () => {
    setShowDateModal(false);
    setItemToEdit(null);
    setViewModeForCurrentRow();
  };

  const handleSaveDate = async () => {
    if (!itemToEdit) {
      setShowDateModal(false);
      clearActiveButtonAction();
      return;
    }
    const payload = {
      key: {
        idPushTTL: itemToEdit?.key?.idPushTTL,
        idJourney: appConfig?.idJourney,
        version: slots?.selectedCampaign?.version
      },
      expiringCampaignDate: campaignEndDate,
      persistenceNotificationDate: persistenceNotificationDate
    }
    const response = await api.updateTemplate(payload)
    if (response && response.status === 200) {
      api.getRunningConfiguration(slots?.selectedCampaign?.version, slots?.selectedCampaign?.templateType)
    } 
    setShowDateModal(false);
    clearActiveButtonAction();
    clearSelectedTtlInState && clearSelectedTtlInState();
  };

  return (
    <>
      <div className="panel-notification-queue-manager">
        <Table
          columns={columns}
          rows={rows}
          isLoading={isLoading}
          emptyDataText="Nessun risultato"
        />
        <div className='buttonContainer'>
            <button className="button button--secondary"
              onClick={(e) => handleDeleteCampaignClick(e)}
              disabled={ isDeleteCampaignButtonDisabled}
            >
              Cancella campagna
            </button>
          </div>
      </div>

    {/* DELETE TTL CONFIRM MODAL */}
      <ConfirmModal
        visible={showDeleteModal}
        title={`Sei sicuro di voler eliminare ${deleteTitle}?`}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        confirmText="CONFERMA"
        cancelText="INDIETRO"
        confirmDisabled={isLoading}
      />
      {/* DELETE CAMPAIGN CONFIRM MODAL */}
        <ConfirmModal
          visible={showDeleteCampaignModal}
          title={`Sei sicuro di voler eliminare la versione ${slots?.selectedCampaign?.version ?? ''}?`}
          onConfirm={handleConfirmDeleteCampaign}
          onCancel={onCancelDeleteCampaign}
          confirmText="CONFERMA"
          cancelText="INDIETRO"
          confirmDisabled={isLoading}
        />
      {/* MODIFY DATE CAMPAIGN MODAL */}
        <ModifyDateModal
          visible={showDateModal}
          title={`Modifica ${(editTitle)} per la versione ${itemToEdit?.key?.version ?? ''}`}
          dateFields={dateFields}
          onSave={handleSaveDate}
          saveLabel='SALVA'
          onCancel={handleCancelDate}
          cancelLabel="INDIETRO"
        />
    </>
  );
};

export default PanelTtlQueueManager;
